// Hero.jsx
import React from "react";
import { Gift, Star } from "lucide-react";
import "./Hero.css";
import mockupHero from "../assets/img/mockup-hero.webp";
import mockupHero2 from "../assets/img/mockup-hero2.webp";
import inicioMockup from "../assets/img/inicio.webp";
import recomendacionesMockup from "../assets/img/recomendaciones.webp";
import recetarioMockup from "../assets/img/recetario.webp";
import analizaMockup from "../assets/img/analiza.webp";
import appStoreImg from "../assets/img/app-store.png";
import googlePlayImg from "../assets/img/google.store.png";
import { trackAppStoreClick, trackGooglePlayClick } from "../analytics/googleAnalytics";

const mockupColumns = [
  {
    className: "mockup-left",
    screens: [
      {
        src: mockupHero,
        alt: "Cuéntale a Wayo lo que has comido, sin foto",
      },
      {
        src: inicioMockup,
        alt: "Pantalla de inicio de Wayo con resumen diario",
      },
      {
        src: recomendacionesMockup,
        alt: "Recomendaciones personalizadas dentro de Wayo",
      },
    ],
  },
  {
    className: "mockup-right",
    screens: [
      {
        src: mockupHero2,
        alt: "El resultado: calorías y macros de tu comida",
      },
      {
        src: analizaMockup,
        alt: "Análisis nutricional de una comida en Wayo",
      },
      {
        src: recetarioMockup,
        alt: "Recetario saludable dentro de Wayo",
      },
    ],
  },
];

export default function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="hero-container">
        
        {/* Badge de confianza - Social proof */}
        <div className="trust-badge">
          <div className="trust-avatars">
            <img className="avatar" src="/assets/img/avatar1.webp" alt="Usuario de Wayo" />
            <img className="avatar" src="/assets/img/avatar2.webp" alt="Usuario de Wayo" />
            <img className="avatar" src="/assets/img/avatar3.webp" alt="Usuario de Wayo" />
          </div>
          <span className="trust-text">
            <Star size={15} strokeWidth={0} fill="#fbbf24" aria-hidden="true" style={{ verticalAlign: "-2px" }} /> <strong>4.9/5</strong> - La App favorita de los que no tienen tiempo.
          </span>
        </div>

        <div className="hero-content">

          {/* Contenido de texto */}
          <div className="hero-text">
            <h1 className="hero-title">
              Controla tus<br />
              calorías con<br />
              <span className="title-highlight">una foto o tu voz</span>
            </h1>

            <p className="hero-description">
              Sin pesar nada y sin buscar en listas interminables. Wayo te da los macros
              al instante y te crea tus planes personalizados de alimentación y entrenamiento.
            </p>

          </div>

          {/* Mockups con carrusel vertical */}
          <div className="hero-mockups">
            {mockupColumns.map((column) => (
              <div className={`mockup-wrapper ${column.className}`} key={column.className}>
                <div className="mockup-viewport" aria-label="Pantallas de la aplicación Wayo">
                  <div className="mockup-scroll">
                    {[0, 1].map((setIndex) => (
                      <div className="mockup-sequence" key={setIndex} aria-hidden={setIndex === 1}>
                        {column.screens.map((screen, screenIndex) => (
                          <div
                            className={`mockup-screen${screenIndex > 0 ? " mockup-screen-cropped" : ""}`}
                            key={`${setIndex}-${screen.alt}`}
                          >
                            <img
                              src={screen.src}
                              alt={screen.alt}
                              className="mockup-img"
                              loading={screenIndex === 0 && column.className === "mockup-right" ? "eager" : "lazy"}
                              fetchPriority={screenIndex === 0 && column.className === "mockup-right" ? "high" : undefined}
                              decoding="async"
                              width="280"
                              height="560"
                            />
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA — badge + stores */}
          <div className="hero-cta">
            <div className="hero-trial-badge">
              <strong><Gift size={16} strokeWidth={2.5} aria-hidden="true" />7 días Premium gratis</strong><br />Escanea sin límites desde el primer día
            </div>

            <div className="store-badges">
              <a
                href="https://apps.apple.com/app/id6756500478"
                className="store-badge app-store"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackAppStoreClick("hero")}
              >
                <img src={appStoreImg} alt="App Store" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.facundosolis.wayo"
                className="store-badge google-play"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackGooglePlayClick("hero")}
              >
                <img src={googlePlayImg} alt="Google Play" />
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* Decoración de fondo */}
      <div className="hero-bg-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3">
          <div className="shape-3-inner"></div>
        </div>
      </div>
    </section>
  );
}
